import axios from "axios";
const appauth_key = "barlays@2029";
let APL_LINK = "http://192.168.1.33:8000/";
// APL_LINK = "http://192.168.164.239:8000/"
APL_LINK = "https://shiprabackend.triosoft.ai/";
let local_server_link_react = APL_LINK + "api/admin_link/";

// API functions

const save_update_point = local_server_link_react + "save_update_point";
const fetch_points = local_server_link_react + "fetch_points";
const update_point_status = local_server_link_react + "update_point_status";
const delete_point = local_server_link_react + "delete_point";
const get_lost_found_list = local_server_link_react + "get_lost_found_list";
const update_lost_found_status =
  local_server_link_react + "update_lost_found_status";
const list_sos_calls = local_server_link_react + "list_sos_calls";
const update_sos_status = local_server_link_react + "update_sos_status";
const dashboard_overview = local_server_link_react + "dashboard_overview";
const fetch_heads_data = local_server_link_react + "fetch_heads_data";
const feedback_dashboard = local_server_link_react + "feedback_dashboard";
const feedback_summary = local_server_link_react + "feedback_summary";

const server_post_data = async (url_for, form_data) => {
  // const headers = {
  //   "Content-Type": "application/json",
  // };

  if (form_data === null) {
    form_data = new FormData();
  }
  // form_data.append("admin_id", retrievedAdminId);
  form_data.append("appauth_key", appauth_key);
  // if (form_data.get("data_call") !== null) {
  //   form_data.append("call_id", retrievedAdminId);
  // }
  return axios.post(url_for, form_data);
};

export {
  APL_LINK,
  appauth_key,
  server_post_data,
  save_update_point,
  fetch_points,
  update_point_status,
  delete_point,
  get_lost_found_list,
  update_lost_found_status,
  list_sos_calls,
  dashboard_overview,
  fetch_heads_data,
  update_sos_status,
  feedback_dashboard,
  feedback_summary,
};
